module.exports = __webpack_public_path__ + "static/media/reportNormal.243b0d37.svg";